import { render, staticRenderFns } from "./copyIndex.vue?vue&type=template&id=fd9a2904&scoped=true&"
import script from "./copyIndex.vue?vue&type=script&lang=js&"
export * from "./copyIndex.vue?vue&type=script&lang=js&"
import style0 from "./copyIndex.vue?vue&type=style&index=0&id=fd9a2904&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9a2904",
  null
  
)

export default component.exports